import { render, staticRenderFns } from "./DoctorsComponent.vue?vue&type=template&id=5177087b&scoped=true"
import script from "./DoctorsComponent.vue?vue&type=script&lang=js"
export * from "./DoctorsComponent.vue?vue&type=script&lang=js"
import style0 from "./DoctorsComponent.vue?vue&type=style&index=0&id=5177087b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5177087b",
  null
  
)

export default component.exports